<div class="layout" [class.no-sidebar]="!showSidebar">
    <upsc-site-announcement *ngIf="shouldDisplaySiteAnnouncement"
                            [siteAnnouncement]="siteAnnouncement"
                            (siteAnnouncementClosed)="onSiteAnnouncementClosed($event)"></upsc-site-announcement>
    <div id="wrapper" [ngClass]="{ 'toggled' : toggleIt }" class="wrapper" [class.with-site-announcement]="!isSiteAnnouncementClosed && shouldDisplaySiteAnnouncement">
        <!-- Sidebar -->
        <upsc-side-bar-menu #sideBarMenu
                            [hidden]="!showSidebar"
                            (notifyToggle)="onMenuToggle($event)"></upsc-side-bar-menu>
        <!-- /#sidebar-wrapper -->

        <!-- Page Content -->
        <div id="page-content-wrapper" class="page-content-wrapper">
            <div class="header-container">
                <upsc-header [isMenuOpened]="isSidenavOpened"
                             (sideNavToggled)="onSidenavToggled($event)"></upsc-header>
            </div>
            <router-outlet></router-outlet>
            <div class="layout-footer">
                &copy; {{ getCurrentYear() }} {{ 'siteFooter' | translate }}
            </div>
        </div>
    </div>
</div>

<!--<mat-sidenav-container>-->
<!--<mat-sidenav #sidenav mode="over" opened="false">-->
<!--<span class="sidenav-toggle" [class.collapsed]="!isSidenavOpened" (click)="onSidenavToggled()">-->
<!--<mat-icon>clear</mat-icon>-->
<!--</span>-->
<!--<upsc-menu [menuItems]="menuItems" [menuStyle]="'vertical'"></upsc-menu>-->
<!--</mat-sidenav>-->

<!--<div class="layout">-->
<!--<upsc-header [user]="userStream | async" (sideNavToggled)="onSidenavToggled()"></upsc-header>-->

<!--<div class="main-content">-->
<!--<router-outlet></router-outlet>-->
<!--</div>-->

<!--&lt;!&ndash;<upsc-footer></upsc-footer>&ndash;&gt;-->
<!--</div>-->
<!--</mat-sidenav-container>-->
